import { useEffect, useRef } from "react";
import marker from "shared/assets/images/marker.png";

export const useLoadImageRef = (mapRef: any) => {
  const loadImageRef = useRef<boolean>(false);
  useEffect(() => {
    if (!loadImageRef.current) {
      const map = mapRef.current?.getMap();
      map?.loadImage(marker, (error: any, image: any) => {
        if (error) throw error;
        if (!map.hasImage("marker-icon"))
          map.addImage("marker-icon", image, { sdf: true });
      });
      loadImageRef.current = true;
    }
  }, [mapRef]);
};
